import { jsx, jsxs } from "react/jsx-runtime";
import { Modal, Box, Heading, Paragraph, Divider, Image, Anchor, Button } from "@zillow/constellation-10";
import { useState, useRef } from "react";
import HubspotEmbed from "../HubspotEmbed/HubspotEmbed.esm.js";
function ContactSalesModal() {
  const [isPostSubmit, setIsPostSubmit] = useState(false);
  const preSubmitRef = useRef(null);
  const observerRef = useRef(null);
  const pollTimerRef = useRef(null);
  const cleanupWatchers = () => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (pollTimerRef.current) {
      window.clearInterval(pollTimerRef.current);
      pollTimerRef.current = null;
    }
  };
  const handleRefAttach = (node) => {
    cleanupWatchers();
    preSubmitRef.current = node;
    if (!node) return;
    const checkForPostSubmit = () => {
      if (node.querySelector(".hsfc-PostSubmit")) {
        setIsPostSubmit(true);
        cleanupWatchers();
        return true;
      }
      return false;
    };
    if (checkForPostSubmit()) return;
    observerRef.current = new MutationObserver(() => {
      checkForPostSubmit();
    });
    observerRef.current.observe(node, {
      childList: true,
      subtree: true
    });
    pollTimerRef.current = window.setInterval(() => {
      checkForPostSubmit();
    }, 500);
  };
  return /* @__PURE__ */ jsx(Modal, { "aria-label": "Contact Sales", className: "contact-sales-modal", size: {
    base: "fullScreen",
    md: "sm"
  }, dividers: false, css: {
    overflowY: "scroll",
    overscrollBehavior: "contain",
    scrollbarColor: "transparent transparent",
    scrollbarWidth: "none"
  }, trigger: /* @__PURE__ */ jsx(Button, { id: "contact-sales-modal-button", "aria-label": "Contact Sales", className: "contact-sales-modal-button", css: {
    display: "none"
  }, emphasis: "filled", tone: "brand", type: "button", children: "Contact Sales" }), children: /* @__PURE__ */ jsxs(Modal.Body, { children: [
    /* @__PURE__ */ jsxs(Box, { id: "contact-sales-modal-pre-submit", ref: handleRefAttach, css: {
      display: isPostSubmit ? "none" : "flex",
      flexDirection: "column",
      paddingInline: "looser",
      paddingBottom: "looser"
    }, children: [
      /* @__PURE__ */ jsx(Heading, { level: 4, css: {
        marginBottom: "default",
        textAlign: "center"
      }, children: "Don't miss out, join the Zillow Pro Interest List" }),
      /* @__PURE__ */ jsx(Paragraph, { css: {
        marginBottom: "default",
        textAlign: "center"
      }, children: "Discover what's next for Top Agents with updates on Zillow Pro - a membership that gives exclusive insights, tools, and visibility to engage leads and clients more intelligently." }),
      /* @__PURE__ */ jsx(Divider, { css: {
        marginBottom: "default"
      } }),
      /* @__PURE__ */ jsx(HubspotEmbed, { region: "na1", portalId: "21555945", embedId: "196810036252", elementId: "hs-embed-196810036252-3niy6w" })
    ] }),
    /* @__PURE__ */ jsxs(Box, { id: "contact-sales-modal-post-submit", css: {
      display: isPostSubmit ? "flex" : "none",
      flexDirection: "column",
      paddingInline: "looser",
      paddingBottom: "looser"
    }, children: [
      /* @__PURE__ */ jsx(Image, { src: "https://www.zillowstatic.com/bedrock/app/uploads/sites/59/2025/10/artwork.png", alt: "Decorative artwork graphic", css: {
        margin: "default",
        alignSelf: "center"
      }, width: "144", height: "144", loading: "eager", decoding: "async" }),
      /* @__PURE__ */ jsx(Heading, { level: 4, css: {
        marginTop: "default",
        marginBottom: "default",
        textAlign: "center"
      }, children: "Thank You!" }),
      /* @__PURE__ */ jsx(Paragraph, { css: {
        marginBottom: "default",
        textAlign: "center"
      }, children: "Our consultants from Zillow Group will call you in the next 1-2 business days." }),
      /* @__PURE__ */ jsx(Divider, { css: {
        marginBottom: "default"
      } }),
      /* @__PURE__ */ jsx(Paragraph, { css: {
        marginBottom: "default",
        textAlign: "center"
      }, children: "During the call, we will discuss your business goals to see if Zillow is a good fit to help you achieve your growth target. If suitable, the next phase includes a free personalized Zillow Premier Agent package tailored to accelerate your business using our data to target the most active buyer markets." }),
      /* @__PURE__ */ jsx(Paragraph, { css: {
        marginBottom: "default",
        textAlign: "center"
      }, children: /* @__PURE__ */ jsx("strong", { children: "Ready to get started now?" }) }),
      /* @__PURE__ */ jsx(Anchor, { href: "https://www.zillow.com/partners/industry-support/", css: {
        textAlign: "center",
        fontWeight: "emphasis"
      }, children: "Explore tools to help navigate industry change" })
    ] })
  ] }) });
}
export {
  ContactSalesModal as default
};
